import React from 'react'
import PlayerRow from './player-row'

export default function PlayersTable(props) {
  const game = props.game
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`

  const guestRows = (pr) => {
    return pr.guests_distributed.map((team, i) => {
      return <tr className='guest' key={i}>
        <td className='col-xs-6 text-left player-name name'>
          <h5>{`${pr.name} + Guest ${i+1}`}</h5>
        </td>
        <td className='col-xs-5'></td>
        <td className='col-xs-1'></td>
      </tr>
    })
  }

  const rows = () => {
    return props.playerReservations.map(pr => {
      const playerRow = [
        <PlayerRow 
          pr={pr}
          key={pr.id}
          onEditCost={props.onEditCost}
          onPayment={props.onPayment}
        />
      ]
      if (pr.guests_distributed.length == 0) return playerRow
      return playerRow.concat(guestRows(pr))
    })
  }
  return <table className='table table-striped text-center'>
    <thead>
      <tr>
        <th>Player Name</th>
        <th>{`Player Cost${currencyName}`}</th>
        <th>Pay</th>
      </tr>
    </thead>
    <tbody className='player-wrapper'>
      { 
        rows()
      }
    </tbody>
  </table>
}
